/**
 * Compliance-related models
 * These will be expanded as compliance features are implemented
 */

/**
 * Compliance report DTO (Response)
 */
export interface ComplianceReportDto {
  id: string;
  reportType: string;
  generatedDate: string;
  reportUrl?: string | null;
  status: string;
  createdAt: string;
}

/**
 * Compliance check DTO (Response)
 */
export interface ComplianceCheckDto {
  id: string;
  leaseId: string;
  checkType: string;
  status: string;
  checkedDate: string;
  notes?: string | null;
  createdAt: string;
}

